import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { debounce, cloneDeep } from "lodash";
import {
  Avatar,
  Breadcrumb,
  Button,
  Col,
  Dropdown,
  Form,
  Input,
  List,
  Menu,
  Modal,
  Row,
  Select,
  Table,
  Tabs,
  Tooltip,
  message,
  InputNumber,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  MobileOutlined,
  UserOutlined,
} from "@ant-design/icons";
import moment from "moment-jalaali";
import { SetRoute } from "../scripts/action";
import { PriceFormat, SearchFormat } from "../scripts/helpers";
import { Constants } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
import UserForm from "../forms/User";
import UserView from "../views/User";

class PhoneOrdersPage extends Component {
  constructor() {
    super();

    this.state = {
      activeTab: "one",
      couriers: [],
      formData: {
        offerCart: 0,
        payableCart: 0,
        products: [],
        total: 0,
        transferringCost: 0,
      },
      orders: [],
      products: [],
      user: {},
    };

    this.types = {
      orderType: {
        voip: Resources.withPhone,
      },
      postType: {
        delivery: Resources.storeCourier,
      },
      payType: {
        cardReader: Resources.pos,
        cash: Resources.cash,
        credit: Resources.credential,
        port: Resources.port,
      },
    };

    this.userFormRef = React.createRef();
    this.voipFormRef = React.createRef();
    this.invoiceFormRef = React.createRef();
    this.searchBoxRef = React.createRef();
    this.searchInputRef = React.createRef();

    this.handleSearch = debounce(this.handleSearch, 500);
  }

  showModal = () => {
    this.setState({ visibleModal: true });

    setTimeout(() => {
      this.userFormRef.current.handleDidMount(this.state.user);
    }, 0);
  };

  hideModal = () => {
    this.setState({ visibleModal: false });

    setTimeout(() => {
      this.userFormRef.current.handleWillUnmount();
    }, 0);
  };

  showDrawer = () => {
    this.setState({ visibleDrawer: true });
  };

  hideDrawer = () => {
    this.setState({ visibleDrawer: false });
  };

  handleCancel = () => {
    Modal.confirm({
      title: Resources.confirmCancelOrder,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.voipFormRef.current.resetFields();
        this.invoiceFormRef.current.resetFields();

        this.props.history.push("/phoneorders");

        this.setState({
          activeTab: "one",
          formData: {
            offerCart: 0,
            payableCart: 0,
            products: [],
            total: 0,
            transferringCost: 0,
          },
          orders: [],
          products: [],
          user: {},
          submitting: false,
        });
      },
    });
  };

  handleFound = (values) => {
    this.props.history.push(`/phoneorders/${values.phone}`);
    this.handleVoipSubmit(values);
  };

  handleFilter = (input, option) => {
    const value = SearchFormat(input);
    const split = value.split(" ");
    let valid = option.code.indexOf(value) >= 0;

    split.forEach((val) => {
      valid = valid || option.name.indexOf(val) >= 0;
    });

    return valid;
  };

  handleCount = (value, record) => {
    const products = [...this.state.formData.products];
    const index = products.findIndex((o) => o.id === record.id);
    const product = products[index];
    product.count = value;
    products.splice(index, 1, product);
    this.setState({
      formData: { ...this.state.formData, ...{ products: products } },
    });
  };

  handleBlur = () => {
    if (!!this.searchBoxRef.current.getFieldValue("search"))
      this.searchBoxRef.current.resetFields();
  };

  handleSelect = (value, clear) => {
    setTimeout(() => {
      if (value) {
        const { formData } = this.state;
        const product = formData.products.find((o) => o.id === value);

        if (product) {
          this.handleCount(product.count + 1, product);
        } else {
          const product = this.state.products.find((o) => o.id === value);
          this.setState({
            formData: {
              ...formData,
              ...{ products: [...formData.products, product] },
            },
          });
        }

        if (clear) {
          this.setState({ products: [] });
          this.searchBoxRef.current.resetFields();
          this.searchInputRef.current.focus();
        }
      } else {
        this.setState({ products: [] });
      }
    }, 5000);
  };

  handleRemove = (id) => {
    const products = [...this.state.formData.products];
    this.setState({
      formData: {
        ...this.state.formData,
        ...{ products: products.filter((o) => o.id !== id) },
      },
    });
  };

  handleSearch = (value) => {
    if (value) {
      API.voip
        .products({ q: SearchFormat(value) })
        .then((result) => {
          if (result.data && result.data.length) {
            const products = result.data.map((o) => {
              return { ...o, ...{ count: 1 } };
            });

            this.setState({ products: products });

            if (products.length === 1) {
              setTimeout(() => {
                this.handleSelect(products[0].id, true);
              }, 0);
            }
          } else {
            this.setState({ products: [] });
          }
        })
        .catch(() => {
          this.setState({ submitting: false });
        });
    }
  };

  handleDistance = (value) => {
    const address = this.state.user.address.find((o) => o.id === value);

    API.voip.distance({ lat: address.lat, lng: address.lng }).then((result) => {
      this.handleTransfer(result.data);
    });
  };

  handleOffer = (value) => {
    this.setState({
      formData: { ...this.state.formData, ...{ offerCart: value } },
    });
  };

  handleTransfer = (value) => {
    this.setState({
      formData: { ...this.state.formData, ...{ transferringCost: value } },
    });
  };

  handleEdit = (record) => {
    const products = record.product.map((o) => {
      return {
        id: o.id,
        name: o.name,
        image: o.gallery && o.gallery.length ? o.gallery[0].image : null,
        code: o.code,
        priceOne: parseInt(o.priceOne),
        priceTwo: parseInt(o.priceTwo),
        count: o.pivot.count,
      };
    });

    this.handleTabChange("two");
    this.invoiceFormRef.current.setFieldsValue({
      addressId: record.address_id,
      paymentType: record.paymentType,
      postType: record.postType,
    });

    this.setState({
      formData: {
        ...this.state.formData,
        ...{
          id: record.id,
          products: products,
          offerCart: parseInt(record.offer),
          transferringCost: parseInt(record.transferringCost),
        },
      },
    });
  };

  handleDelete = (record) => {
    Modal.confirm({
      title: Resources.confirmDeleteOrder,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.order
          .delete(record)
          .then((result) => {
            message.success(result.message);

            this.handleVoipSubmit(this.state.user, true);
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleVoipSubmit = (values, reload) => {
    this.setState({ submitting: true });

    API.voip
      .user(values)
      .then((result) => {
        if (result.status === 0) {
          const user = {};

          if (values.phone.toString().startsWith("09"))
            user.phone = values.phone;
          else user.phones = [{ id: 1, phone: values.phone }];

          message.info(result.message);
          this.setState({ submitting: false, user: user });
          this.showModal();
        } else {
          this.setState({
            submitting: false,
            user: result.data,
            orders: result.cart,
          });

          if (!reload) {
            this.handleTabChange("two");
            this.invoiceFormRef.current.setFieldsValue({
              paymentType: "cardReader",
              postType: "delivery",
            });
          }
        }
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleUserSubmit = (values) => {
    if (!this.state.submitting) {
      const action = this.state.user.id ? API.user.update : API.user.add;

      this.setState({ submitting: true });

      action(values, this.state.user.id)
        .then((result) => {
          message.success(result.message);
          this.hideModal();
          this.handleFound({ phone: this.state.user.phone }, true);
        })
        .catch(() => {
          this.setState({ submitting: false });
        });
    }
  };

  handleInvoiceSubmit = (cancel) => {
    this.invoiceFormRef.current.validateFields().then((values) => {
      const cloneData = cloneDeep({
        ...this.state.formData,
        ...values,
        ...{
          status: cancel ? 0 : 1,
          phone: this.state.user.phone,
          orderType: "voip",
        },
      });
      const action = cloneData.id ? API.order.update : API.order.add;
      const address = this.state.user.address.find(
        (o) => o.id === cloneData.addressId
      );

      cloneData.lat = address.lat;
      cloneData.lng = address.lng;
      cloneData.address = address.address;
      cloneData.products = cloneData.products.map((o) => {
        const price = o.priceOne * o.count;
        const discount = o.priceTwo ? (o.priceOne - o.priceTwo) * o.count : 0;

        return {
          product_id: o.id,
          count: o.count,
          price: price,
          payable: price - discount,
          offer: discount,
        };
      });

      this.setState({ submitting: true });

      action(cloneData, cloneData.id)
        .then((result) => {
          message.success(result.message);

          this.voipFormRef.current.resetFields();
          this.invoiceFormRef.current.resetFields();

          this.props.history.push("/phoneorders");

          this.setState({
            activeTab: "one",
            formData: {
              offerCart: 0,
              payableCart: 0,
              products: [],
              total: 0,
              transferringCost: 0,
            },
            orders: [],
            products: [],
            user: {},
            submitting: false,
          });
        })
        .catch(() => {
          this.setState({ submitting: false });
        });
    });
  };

  handleInvoiceSuspend = () => {
    Modal.confirm({
      title: Resources.confirmSuspendOrder,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.handleInvoiceSubmit(true);
      },
    });
  };

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;
    const { phone } = this.props.match.params;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    API.user.list({ level: ["postman"] }).then((result) => {
      this.setState({ couriers: result.data || [] });
    });

    if (phone) {
      if (!phone.startsWith("0")) {
        this.props.history.replace(`/phoneorders/0${phone}`);
        this.voipFormRef.current.setFieldsValue({ phone: `0${phone}` });
        this.handleVoipSubmit({ phone: `0${phone}` });
      } else {
        this.voipFormRef.current.setFieldsValue({ phone: phone });
        this.handleVoipSubmit({ phone: phone });
      }
    }
  }

  render() {
    const {
      activeTab,
      couriers,
      formData,
      orders,
      products,
      submitting,
      user,
      visibleDrawer,
      visibleModal,
    } = this.state;

    const columns = [
      {
        title: Resources.title,
        dataIndex: "name",
      },
      {
        title: Resources.image,
        dataIndex: "image",
        width: "50px",
        render: (val) => (
          <Tooltip
            title={
              <Avatar
                src={`${Constants.imagePathProduct}${val}`}
                shape="square"
                size={200}
              />
            }
          >
            <Avatar
              src={`${Constants.imagePathProduct}${val}`}
              shape="square"
              size="small"
            />
          </Tooltip>
        ),
      },
      {
        title: Resources.barcode,
        dataIndex: "code",
        className: "col-center",
        width: "150px",
      },
      {
        title: Resources.inventory,
        dataIndex: "inventory",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.count,
        dataIndex: "count",
        className: "col-center",
        width: "100px",
        render: (val, record) => (
          <InputNumber
            min={1}
            value={val}
            onChange={(value) => this.handleCount(value, record)}
            style={{ width: "100%" }}
            size="large"
          />
        ),
      },
      {
        title: `${Resources.price} (${Resources.rial})`,
        dataIndex: "priceOne",
        className: "col-center",
        width: "120px",
        render: (val) => PriceFormat(val),
      },
      {
        title: Resources.discount,
        dataIndex: "priceTwo",
        className: "col-center",
        width: "100px",
        render: (val, record) => (val ? PriceFormat(record.priceOne - val) : 0),
      },
      {
        title: `${Resources.price} (${Resources.rial})`,
        dataIndex: "sum",
        className: "col-center",
        width: "160px",
        render: (val, record) =>
          PriceFormat(
            (record.priceTwo ? record.priceTwo : record.priceOne) * record.count
          ),
      },
      {
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "80px",
        render: (val) => (
          <Tooltip title={Resources.delete}>
            <Button
              type="link"
              icon={<DeleteOutlined />}
              onClick={() => this.handleRemove(val)}
            />
          </Tooltip>
        ),
      },
    ];

    const ordrColumns = [
      {
        title: Resources.dateAndTime,
        dataIndex: "created_at",
        className: "col-ltr",
        render: (val) => moment(val).format(Constants.jDateTimeFormat),
      },
      {
        title: `${Resources.type} ${Resources.order}`,
        dataIndex: "orderType",
        className: "col-center",
        render: (val) => this.types.orderType[val],
      },
      {
        title: `${Resources.amount} ${Resources.total} (${Resources.rial})`,
        dataIndex: "total",
        className: "col-center",
        render: (val) => PriceFormat(val),
      },
      {
        title: `${Resources.type} ${Resources.payment}`,
        dataIndex: "paymentType",
        className: "col-center",
        render: (val) => this.types.payType[val],
      },
      {
        title: `${Resources.type} ${Resources.submit}`,
        dataIndex: "postType",
        className: "col-center",
        render: (val) => this.types.postType[val],
      },
      {
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            <Tooltip title={Resources.edit}>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.handleEdit(record)}
              />
            </Tooltip>
            <Tooltip title={Resources.delete}>
              <Button
                type="link"
                icon={<DeleteOutlined />}
                onClick={() => this.handleDelete(record)}
              />
            </Tooltip>
          </Fragment>
        ),
      },
    ];

    const menu = (
      <Menu>
        <Menu.Item onClick={this.showDrawer}>
          <EyeOutlined /> {Resources.view}
        </Menu.Item>
        <Menu.Item onClick={this.showModal}>
          <EditOutlined /> {Resources.edit}
        </Menu.Item>
      </Menu>
    );

    formData.total = 0;
    formData.products.forEach((o) => {
      formData.total += (o.priceTwo || o.priceOne) * o.count;
    });
    formData.payableCart =
      formData.total + formData.transferringCost - formData.offerCart;

    return (
      <Fragment>
        {!!user.id && (
          <Dropdown overlay={menu} className="user-preview">
            <Button type="link" icon={<UserOutlined />} size="small">
              {user.name} {user.family}
            </Button>
          </Dropdown>
        )}
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.phoneOrders}</Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Tabs
            activeKey={activeTab}
            type="card"
            onTabClick={this.handleTabChange}
          >
            <Tabs.TabPane
              tab={`${Resources.select} ${Resources.user}`}
              key="one"
            >
              <Form ref={this.voipFormRef} onFinish={this.handleFound}>
                <Row gutter={24}>
                  <Col xs={24} sm={10} md={8}>
                    <Form.Item name="phone" rules={Rules.required}>
                      <Input
                        type="text"
                        size="large"
                        prefix={<MobileOutlined />}
                        placeholder={Resources.mobilePhone}
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={{ span: 6, offset: 8 }}
                    md={{ span: 4, offset: 12 }}
                  >
                    <Form.Item>
                      <Button
                        type="primary"
                        size="large"
                        htmlType="submit"
                        loading={submitting}
                        block
                      >
                        {Resources.submit}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Tabs.TabPane>
            <Tabs.TabPane
              tab={`${Resources.record} ${Resources.order}`}
              key="two"
              disabled={!user.id}
            >
              <Form ref={this.searchBoxRef}>
                <Form.Item name="search">
                  <Select
                    allowClear
                    filterOption={(input, option) =>
                      this.handleFilter(input, option)
                    }
                    onSearch={this.handleSearch}
                    onChange={(val) => this.handleSelect(val, false)}
                    onBlur={this.handleBlur}
                    placeholder={Resources.search}
                    ref={this.searchInputRef}
                    className="ant-select-xl"
                    size="large"
                    showSearch
                  >
                    {products.map((o) => (
                      <Select.Option
                        key={o.id}
                        value={o.id}
                        name={o.name}
                        code={o.code}
                      >
                        {o.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Form>
              <Table
                columns={columns}
                dataSource={formData.products}
                pagination={false}
                size="small"
                rowKey="id"
                scroll={{ x: 1000 }}
              />
              <List
                size="small"
                style={{ backgroundColor: "#fafafa", marginBottom: 8 }}
              >
                <List.Item>
                  <List.Item.Meta
                    title={`${Resources.sum} ${Resources.factor}`}
                    style={{ marginRight: 8 }}
                  />
                  <span
                    style={{ width: 120, marginLeft: 80, textAlign: "center" }}
                  >
                    {PriceFormat(formData.total)}
                  </span>
                </List.Item>
                <List.Item>
                  <List.Item.Meta
                    title={Resources.transferCost}
                    description={Resources.transferCostHelp}
                    style={{ marginRight: 8 }}
                  />
                  <span style={{ width: 120, marginLeft: 80 }}>
                    <InputNumber
                      value={formData.transferringCost}
                      min={0}
                      onChange={this.handleTransfer}
                      style={{ width: "100%" }}
                    />
                  </span>
                </List.Item>
                <List.Item>
                  <List.Item.Meta
                    title={Resources.discount}
                    style={{ marginRight: 8 }}
                  />
                  <span style={{ width: 120, marginLeft: 80 }}>
                    <InputNumber
                      value={formData.offerCart}
                      min={0}
                      max={formData.total + formData.transferringCost}
                      onChange={this.handleOffer}
                      style={{ width: "100%" }}
                    />
                  </span>
                </List.Item>
                <List.Item>
                  <List.Item.Meta
                    title={Resources.finalPrice}
                    style={{ marginRight: 8 }}
                  />
                  <span
                    style={{ width: 120, marginLeft: 80, textAlign: "center" }}
                  >
                    {PriceFormat(formData.payableCart)}
                  </span>
                </List.Item>
              </List>
              <Form
                ref={this.invoiceFormRef}
                onFinish={this.handleInvoiceSubmit}
                layout="vertical"
              >
                <Row gutter={24}>
                  <Col xs={24}>
                    <Form.Item
                      name="addressId"
                      label={Resources.address}
                      rules={Rules.required}
                    >
                      <Select
                        placeholder={Resources.choose}
                        onSelect={this.handleDistance}
                      >
                        {user.address &&
                          user.address.map((o) => (
                            <Select.Option key={o.id} value={o.id}>
                              {o.address}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name="paymentType"
                      label={`${Resources.type} ${Resources.payment}`}
                      rules={Rules.required}
                    >
                      <Select placeholder={Resources.choose}>
                        <Select.Option value="cardReader">
                          {Resources.pos}
                        </Select.Option>
                        <Select.Option value="cash">
                          {Resources.cash}
                        </Select.Option>
                        <Select.Option value="credit">
                          {Resources.credential}
                        </Select.Option>
                        <Select.Option value="port">
                          {Resources.port}
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name="postType"
                      label={`${Resources.type} ${Resources.submit}`}
                      rules={Rules.required}
                    >
                      <Select placeholder={Resources.choose}>
                        <Select.Option value="delivery">
                          {Resources.storeCourier}
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={8}>
                    <Form.Item
                      name="postman_id"
                      label={`${Resources.firstName} ${Resources.postman}`}
                    >
                      <Select placeholder={Resources.choose}>
                        {couriers.map((o) => (
                          <Select.Option key={o.id} value={o.id}>
                            {o.name} {o.family}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24} style={{ paddingTop: 24 }}>
                  <Col
                    xs={24}
                    sm={{ span: 6, offset: 6 }}
                    lg={{ span: 3, offset: 15 }}
                  >
                    <Form.Item>
                      <Button
                        type="default"
                        onClick={this.handleCancel}
                        loading={submitting}
                        block
                      >
                        {Resources.cancel}
                      </Button>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={6} lg={3}>
                    <Form.Item>
                      <Button
                        type="danger"
                        onClick={() => this.handleInvoiceSuspend()}
                        loading={submitting}
                        disabled={!formData.products.length}
                        block
                      >
                        {Resources.suspension}
                      </Button>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={6} lg={3}>
                    <Form.Item>
                      <Button
                        type="primary"
                        onClick={() => this.handleInvoiceSubmit()}
                        loading={submitting}
                        disabled={!formData.products.length}
                        block
                      >
                        {Resources.submit}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Tabs.TabPane>
            <Tabs.TabPane
              tab={Resources.suspensionFactors}
              key="three"
              disabled={!user.id}
            >
              <Table
                columns={ordrColumns}
                dataSource={orders}
                loading={submitting}
                pagination={false}
                size="small"
                rowKey="id"
                scroll={{ x: 800 }}
              />
            </Tabs.TabPane>
          </Tabs>
        </div>
        <UserForm
          ref={this.userFormRef}
          onCancel={this.hideModal}
          onSubmit={this.handleUserSubmit}
          submitting={submitting}
          visible={visibleModal}
        />
        <UserView
          data={user}
          visible={visibleDrawer}
          onClose={this.hideDrawer}
        />
      </Fragment>
    );
  }
}

export default connect(null, (dispatch) => {
  return {
    onSetRoute: (data) => dispatch(SetRoute(data)),
  };
})(PhoneOrdersPage);
